export default __webpack_public_path__ + "static/media/ramp-right.0747aeb2.svg";